// extracted by mini-css-extract-plugin
export var link = "blog-categories-module--link--2Whnl";
export var categories = "blog-categories-module--categories--39DGj";
export var item = "blog-categories-module--item--YgGxR";
export var active = "blog-categories-module--active--1kO-0";